import React from 'react';

import AppContent from '../_Shared/Layout/AppContent';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';

const _ = require('lodash');

class ProviderEdit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            provider: props.provider
        }
    }

    componentDidMount() {
        this.props.onActivate();
    }

    componentDidUpdate(prevProps, prevState) {
        const { provider } = this.props;
        if (provider !== null && !_.isEqual(prevProps.provider, provider)) {
            this.setState({ provider });
        }
    }

    handleInputChange = (name, value) => {
        this.setState((prevProps, state) => {
            return { provider: Object.assign({}, prevProps.provider, { [name]: value }) }
        });
    }

    updateProvider = e => {
        const { onProviderUpdated } = this.props;
        const { provider } = this.state;
        onProviderUpdated(Object.assign({}, provider));
    }

    render() {
        const { loading } = this.props;
        const { provider } = this.state;
        return (<AppContent>
            <Grid container spacing={24}> 
                {
                    loading &&
                    <Grid container item spacing={24}><Grid item xs><LinearProgress variant="query" color="secondary" /></Grid></Grid>
                }

                <Grid container item spacing={24}>
                    <Grid item lg={6} xl={4}>
                        <TextField autoFocus value={provider.name} onChange={e => this.handleInputChange('name', e.target.value)} id="name" name="name" label="Provider Name" type="text" fullWidth />
                    </Grid>
                </Grid>

                <Grid container item spacing={24}>
                    <Grid item lg={6} xl={4}>
                        <Button onClick={this.updateProvider} variant="contained" color="secondary">Save</Button>
                    </Grid>
                </Grid>
            </Grid>
        </AppContent >)
    }
}
export default ProviderEdit;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Providers/ProviderEdit.js